<template>
  <div class="flex flex-col gap-2">
    <label :for="id" class="font-medium text-dark-600 dark:text-dark-50">{{ label }}</label>
    <InputNumber :id="id" :name="name" type="text" :modelValue="modelValue" @input="handleInput"
      class="w-full border border-gray-400 rounded-md text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-dark-900"
      :class="input_class" :disabled="disabled" :invalid="!valid" fluid />
    <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
    </Message>
  </div>
</template>

<script>
import { InputNumber, Message } from 'primevue';

export default {
  name: 'InputNumberCustom',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    input_class: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Number],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  components: {
    Message, InputNumber
  },
  methods: {
    handleInput(event) {
      // Emit the raw numeric value
      this.$emit('update:modelValue', event?.value);
    }
  }
}
</script>
